/** @format */

import React, { useState } from "react";
import { BsToggleOff, BsToggleOn } from "react-icons/bs";

type faqCardProps = {
  title: string;
  description?: string;
  index: number;
  activeIndex: number;
  setActiveIndex: React.Dispatch<React.SetStateAction<number>>;
};

const FaqCard = ({
  title,
  description,
  index,
  activeIndex,
  setActiveIndex,
}: faqCardProps) => {
  const [active, setActive] = useState(false);
  const handleSetIndex = (index: number) => {
    activeIndex !== index && setActiveIndex(index);
    setActive(!active);
  };

  return (
    <div className="faq-card h-fit relative">
      <div
        onClick={() => handleSetIndex(index)}
        className="flex justify-between"
      >
        <h3
          className={`font-bold text-[18px] text-[#313131] leading-[130%] cursor-pointer`}
        >
          {title}
        </h3>
        <div className="cursor-pointer">
          {activeIndex === index && active ? (
            <BsToggleOn size={20} color="purple" />
          ) : (
            <BsToggleOff size={20} />
          )}
        </div>
      </div>
      {activeIndex === index && active && (
        <div className="pt-[35px] pb-[35px] absolute z-10 bg-white left-0 px-8 shadow-sm rounded-b-xl">
          <p className="">{description}</p>
        </div>
      )}
    </div>
  );
};

export default FaqCard;
